const baseOptions: Partial<Highcharts.Options> = {
  title: undefined,
  tooltip: {
    xDateFormat: "%A, %d-%m-%Y %H:%M",
  },
  colors: ["#8FCAE7", "#01689B", "#CCE0F1"],
  legend: {
    padding: 0,
  },
  yAxis: {
    gridZIndex: 2,
    labels: {
      reserveSpace: true,
    },
  },
  chart: {
    marginLeft: 65,
    marginRight: 35,
  },
};

export default baseOptions;
